module.exports = __webpack_public_path__ + "static/media/footer-tendances-active.2064f943.png";